/** Save a base64-encoded PDF (as returned by the API) to the user's disk. */
export function downloadPdf(base64: string, filename: string) {
	const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
	const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
	// Attached + deferred revoke: Firefox/Safari may drop a detached or
	// already-revoked download
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	document.body.appendChild(link)
	link.click()
	link.remove()
	setTimeout(() => URL.revokeObjectURL(url), 1000)
}
